module.exports = __webpack_public_path__ + "static/media/location.b472e06f.svg";